var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row wrapper-picture_hp hide-on-small-only"},[_c('span',{staticClass:"copyright",attrs:{"role":"droit auteur photo","aria-label":"droit auteur photo"}},[_vm._v("Illustration : IStockPhoto")])])
}]

export { render, staticRenderFns }